/* eslint-disable no-undef */
export const API_WALLET_URL =
  process.env.REACT_APP_API_WALLET_URL || 'http://localhost:3000'
export const API_LOANS_URL = process.env.REACT_APP_API_LOANS_URL
export const API_AUTH_URL =
  process.env.REACT_APP_API_AUTH_URL || 'http://localhost:3000'
export const API_SUBSCRIPTIONS_URL = process.env.REACT_APP_API_SUBSCRIPTION_URL
export const ENVIRONMENT = process.env.REACT_APP_ENV || 'development'
export const FACEBOOK_CALLBACK = process.env.REACT_APP_FACEBOOK_CALLBACK || ''
export const GOOGLE_CALLBACK = process.env.REACT_APP_GOOGLE_CALLBACK || ''
export const URL_AUTOGESTION = process.env.REACT_APP_URL_AUTOGESTION || ''
export const URL_RENOVADOR = process.env.REACT_APP_URL_RENOVADOR || ''
export const URL_ONBOARDING = process.env.REACT_APP_URL_ONBOARDING || ''
export const URL_BENEFICIOS = process.env.REACT_APP_URL_BENEFICIOS || ''
export const URL_MEMBRESIAS = process.env.REACT_APP_URL_MEMBERSHIP || ''
export const URL_LANDING = process.env.REACT_APP_URL_LANDING
export const URL_ME = process.env.REACT_APP_URL_ME || ''
export const URL_TERM = process.env.REACT_APP_URL_TERM || ''
export const URL_CARDS = process.env.REACT_APP_URL_CARDS || ''
export const URL_ACTIVITIES = process.env.REACT_APP_URL_ACTIVITIES || ''

export const URL_CREDIT_PROFILE = process.env.REACT_APP_CREDIT_PROFILE || ''

// Google sheet
export const GOOGLE_SHEET_URL = process.env.REACT_APP_GOOGLE_SHEET_URL

export const COMERCIOS_AFILIADOS_URL =
  process.env.REACT_APP_COMERCIOS_AFILIADOS_URL
export const PROMOCIONES_MASTERCARD_URL =
  process.env.REACT_APP_PROMOCIONES_MASTERCARD_URL

export const GTM_ID = process.env.REACT_APP_GOOGLE_GTM

export const ZENDESK_URL = process.env.REACT_APP_WAYNI_ZENDESK

export const SOCIAL_LINKS = {
  fb: process.env.REACT_APP_URL_FACEBOOK,
  ig: process.env.REACT_APP_URL_INSTAGRAM,
  x: process.env.REACT_APP_URL_X
}

export const APP_URL = {
  ios: process.env.REACT_APP_APP_IOS,
  android: process.env.REACT_APP_APP_ANDROID
}

export const MEMBERSHIP_PRICE = Number(process.env.REACT_APP_MEMBERSHIP_PRICE)

export const URL_MOENGAGE = process.env.REACT_APP_API_MOENGAGE_URL
export const MOENGAGE_EXPERIENCE_TOKEN =
  process.env.REACT_APP_MOENGAGE_EXP_TOKEN
export const MOENGAGE_LIVE_API_KEY = process.env.REACT_APP_MOENGAGE_LIVE_API_KEY

export const CASH_OUT_MAINTENANCE =
  process.env.REACT_APP_CASH_OUT_MAINTENANCE === 'true'
